if (!customElements.get('b2b-header')) {
  class B2BHeader extends HTMLElement {
    constructor() {
      super();
      this.toggles = Array.from(this.querySelectorAll('[data-panel-toggle]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.openPanel = null;
      this.mobileQuery = window.matchMedia('(min-width: 990px)');

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.toggles.forEach((toggle) => toggle.addEventListener('click', this.onToggleClick.bind(this, toggle)));
      this.addEventListener('keyup', this.onKeyUp);
      this.mobileQuery.addEventListener('change', this.onBreakpointChange);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
    }

    onToggleClick(toggle, event) {
      event.preventDefault();
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;

      if (this.openPanel === panel) {
        this.close();
        return;
      }

      this.open(panel, toggle);
    }

    open(panel, toggle) {
      if (this.openPanel) this.close({ focusToggle: false, animate: false });

      this.openPanel = panel;
      this.activeToggle = toggle;
      panel.hidden = false;
      this.setExpanded(panel, true);
      this.classList.add('b2b-header--panel-open');

      this.animate(panel, { opacity: [0, 1], transform: ['translateY(-6px)', 'translateY(0)'] });

      if (toggle.hasAttribute('data-focus-search')) {
        panel.querySelector('input[type="search"]')?.focus();
      }

      document.addEventListener('click', this.onDocumentClick);
    }

    close({ focusToggle = false, animate = true } = {}) {
      const panel = this.openPanel;
      if (!panel) return;

      const toggle = this.activeToggle;
      this.openPanel = null;
      this.activeToggle = null;
      this.setExpanded(panel, false);
      this.classList.remove('b2b-header--panel-open');
      document.removeEventListener('click', this.onDocumentClick);

      const hide = () => {
        if (this.openPanel !== panel) panel.hidden = true;
      };

      if (animate) {
        this.animate(panel, { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-6px)'] }, 0.15).then(hide);
      } else {
        hide();
      }

      if (focusToggle && toggle) toggle.focus();
    }

    setExpanded(panel, expanded) {
      this.toggles
        .filter((toggle) => toggle.getAttribute('aria-controls') === panel.id)
        .forEach((toggle) => toggle.setAttribute('aria-expanded', expanded));
    }

    animate(panel, keyframes, duration = 0.2) {
      if (!window.Theme?.motion || Theme.config?.motionReduced) return Promise.resolve();
      return Theme.motion.animate(panel, keyframes, { duration, easing: 'ease' }).finished;
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    onKeyUp(event) {
      if (event.code !== 'Escape' || !this.openPanel) return;
      // Let predictive search handle Escape while its results are open
      if (event.target.closest('predictive-search[open]')) return;
      this.close({ focusToggle: true, animate: false });
    }

    onBreakpointChange() {
      this.close({ animate: false });
    }
  }

  customElements.define('b2b-header', B2BHeader);
}
